import gate from '@/api/axios';

export const createSupportMessageTemplate = async (payload) => gate.post(
  '/configs/supportTemplates',
  payload,
);

export const supportMessageTemplateVersions = async (key) => gate.get(
  `/configs/supportTemplates/${encodeURIComponent(key)}/versions`,
);

export const restoreSupportMessageTemplateVersion = async (key, version) => gate.post(
  `/configs/supportTemplates/${encodeURIComponent(key)}/versions/${version}/restore`,
);
